/* eslint-disable */
import Filters from './Filters';
import MainTabs from './Components/MainTabs';
import AnalysisTabs from './Components/AnalysisTabs';

const HeaderSection = ({ hideFilters = false }) => {
	return (
		<div className=" border-gray-200">
			{/* Main Navigation Tabs */}
			<MainTabs />

			{/* Analysis Tabs */}
			<AnalysisTabs />
			
			{/* Filters Section */}
			{!hideFilters && <Filters />}
		</div>
	);
};
export default HeaderSection;
